import { NavLink } from "react-router-dom";

import "./PosterSmall.css";

export default function PosterSmall({ imdb_id, poster_path, title, rating, year }) {
  return (
    <div>
      <div className="group-block-poster-small">
        <NavLink to={`/movie-info/${imdb_id}`}>
          <div>
            <img
              src={`https://image.tmdb.org/t/p/w220_and_h330_face${poster_path}`}
              height={"360px"}
              alt="cell"
              className="img-block-poster-small"
            />
            <div className="text-block-poster-small">
              <p className="year-poster-small">{year}</p>
            </div>
          </div>
        </NavLink>
        {/* <div>Rating: {rating}</div> */}
      </div>
      <div className="title-block-poster-small">
        <div className="title-poster-small"><b>{title}</b></div>
        <b style={{ color: "#bbbbbb" }}>Rating:</b> {rating.toFixed(1)}
      </div>
    </div>
  );
}
